import styles from "./Library.module.css";
import { IconFilter } from "components/Icons/IconFilter";
import { IconMagnifyingGlass } from "components/Icons/IconMagnifyingGlass";
import { IconButton } from "components/Button/IconButton";
import { InputField } from "components/Input/InputField";
import { ClickPopover } from "components/ClickPopover";
import { Filters } from "./Filters";
import type { TabName } from "./useActiveTab";
import useFreetextFilterState from "gui/browse-shared/useFreetextFilterState";

interface Props {
  activeTab?: TabName;
}

export function SearchAndFilters(props: Props) {
  const { activeTab } = props;
  const { freetextFilter, setFreetextFilter } = useFreetextFilterState();

  return (
    <div className={styles.searchAndFilters}>
      <InputField
        size="M"
        style="contained"
        placeholder={`Search your ${
          activeTab === "library" ? "folders" : "content"
        }...`}
        value={freetextFilter}
        onChange={(event) => {
          setFreetextFilter(event.target.value);
        }}
        prefix={<IconMagnifyingGlass />}
      />
      {activeTab !== "library" && (
        <div>
          <ClickPopover
            content={() => <Filters activeTab={activeTab} />}
            position="below-align-right"
            closeOnClickOutside={true}
          >
            <IconButton theme="tertiary" size="M">
              <IconFilter />
            </IconButton>
          </ClickPopover>
        </div>
      )}
    </div>
  );
}
